import DashboardIcon from './DashboardIcon'
import KeyboardIcon from './KeyboardIcon'
import MicrophoneIcon from './MicrophoneIcon'
import MicrophoneIconOn from './MicrophoneIconOn'

export {
  DashboardIcon,
  KeyboardIcon,
  MicrophoneIcon,
  MicrophoneIconOn
}
